import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import AdvancedCarePolicyPage from "@/portals/(shared)/AdvancedCarePolicyPage";
import { DashboardRouter } from "@/containers/Dashboard/DashboardRouter";
import HipaaPolicyPage from "@/portals/(shared)/HipaaPolicyPage";
import PricingPage from "@/portals/(shared)/PricingPage";
import PrivacyPolicy from "@/components/Common/PrivacyPolicy";
import PrivacyPolicyPage from "@/portals/(shared)/PrivacyPolicyPage";
import RedirectSplashScreen from "@/redirectSplashScreen";
import TermsAndConditionsPolicyPage from "@/portals/(shared)/TermsAndConditionsPolicyPage";
import TreatmentPolicyPage from "@/portals/(shared)/TreatmentPolicyPage";
import Unsubscribe from "@/components/Common/Unsubscribe";

export const getAuthenticatedRoutes = (props) => (
  <Switch>
    <Route
      path={props.auth.authRedirectPath}
      render={(compProps) => <DashboardRouter {...compProps} role={props.auth.role} />}
    />

    <Route
      component={(compProps) => (
        <RedirectSplashScreen {...compProps} redirectPath={props.auth.authRedirectPath} />
      )}
      path="/redirect"
    />

    <Route component={AdvancedCarePolicyPage} path="/advanced-care" />
    <Route component={HipaaPolicyPage} path="/hipaaprivacy" />
    <Route component={PricingPage} path="/session-pricing" />
    <Route component={PrivacyPolicyPage} path="/privacy" />
    <Route component={TermsAndConditionsPolicyPage} path="/terms-and-conditions" />
    <Route component={TreatmentPolicyPage} path="/consent" />
    <Route component={Unsubscribe} path="/unsubscribe" />
    <Route component={PrivacyPolicy} path="/privacy-policy" />

    <Redirect from="/auth" to={props.auth.authRedirectPath} />
    <Redirect to="/redirect" />
  </Switch>
);
